<div class="section-body">

 <!--  <div class="col-12 col-lg-12">
    <div class="card">
      <div class="card-header card-success">
        <h4>Help Guides And Videos</h4>                 
      </div>
      <div class="card-body"> -->


    <!--     <div id="accordion" *ngIf="wall_1||wall_2||wall_3||wall_4">
          <div class="accordion">
            <div class="accordion-header" role="button" data-toggle="collapse" data-target="#panel-body-1"
            aria-expanded="true">
            <h4>WallBoard<span class="fr"><i class="fas fa-plus"></i></span>	</h4>	
          </div>
          <div class="accordion-body help-manual-groups collapse show" id="panel-body-1" data-parent="#accordion">
            <div class="accord-btn-group">
              <div class="row">
                <div class="col-sm-6 col-12" *ngIf="wall_1"> 
                  <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/WallBoard Basic.pdf')" target="_blank" class="btn btn-info">Wallborad<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
                </div>
                <div class="col-sm-6 col-12" *ngIf="wall_2"> 
                  <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/Advance wallboard 1.pdf')" target="_blank" class="btn btn-info">Advanced Wallborad 1<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
                </div>
                <div class="col-sm-6 col-12" *ngIf="wall_3"> 
                  <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/Advance wallboard 2.pdf')" target="_blank" class="btn btn-info"> Advanced Wallborad 2<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
                </div>
                <div class="col-sm-6 col-12" *ngIf="wall_4"> 
                  <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/Advance wallboard 3.pdf')" target="_blank" class="btn btn-info">Advanced Wallborad 3<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
                </div>
                <div class="col-sm-6 col-12" *ngIf="wall_4"> 
                  <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/Advance wallboard 4.pdf')" target="_blank" class="btn btn-info">Advanced Wallborad 4<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
 -->
  <!--     
      <div id="accordion">
        <div class="accordion">
          <div class="accordion-header" role="button" data-toggle="collapse" data-target="#panel-body-2" aria-expanded="true">
          <h4>Manage<span class="fr"><i class="fas fa-plus"></i></span>	</h4>	
        </div>
        <div class="accordion-body help-manual-groups collapse show" id="panel-body-2" data-parent="#accordion">
          <div class="accord-btn-group">
            <div class="row">
              <div class="col-sm-6 col-12" *ngIf="h_contact"> 
                <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/Contacts.pdf')" target="_blank" class="btn btn-info">Contacts<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
              </div>
              <div class="col-sm-6 col-12" *ngIf="h_lead"> 
                <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/Leads.pdf')" target="_blank" class="btn btn-info">Leads<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
              </div>
              <div class="col-sm-6 col-12" *ngIf="h_sms"> 
                <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/sms-temp.pdf')" target="_blank" class="btn btn-info">SMS Template<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
              </div>
              <div class="col-sm-6 col-12" *ngIf="h_sms"> 
                <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/sms-groups.pdf')" target="_blank" class="btn btn-info">SMS Groups<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
              </div>
              <div class="col-sm-6 col-12" *ngIf="this.hide_admin_sett"> 
                <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/Departments.pdf')" target="_blank" class="btn btn-info">Departments<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
              </div>
              <div class="col-sm-6 col-12" *ngIf="h_voice3cx"> 
                <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/wrapup%20Module.pdf')" target="_blank" class="btn btn-info">Wrapup Code<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
              </div>
              <div class="col-sm-6 col-12" *ngIf="this.hide_admin_sett"> 
                <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/Agents.pdf')" target="_blank" class="btn btn-info">Agents<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

  <!--   <div id="accordion" *ngIf="h_voice3cx">
      <div class="accordion">
        <div class="accordion-header" role="button" data-toggle="collapse" data-target="#panel-body-3" aria-expanded="true">
          <h4>Voice 3CX<span class="fr"><i class="fas fa-plus"></i></span></h4>	
        </div>
      <div class="accordion-body help-manual-groups collapse show" id="panel-body-3" data-parent="#accordion">
        <div class="accord-btn-group">
          <div class="row">
            <div class="col-sm-6 col-12" > 
              <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/Aux%20Code%20Module.pdf')" target="_blank" class="btn btn-info">Aux Code<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
            </div>
            <div class="col-sm-6 col-12"> 
              <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/queue.pdf')" target="_blank" class="btn btn-info">Queue<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
            </div>
            <div class="col-sm-6 col-12" > 
              <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/pbx.pdf')" target="_blank" class="btn btn-info">PBX Settings<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
<!-- 
      <div id="accordion" *ngIf="h_voice3cx">
          <div class="accordion">
            <div class="accordion-header" role="button" data-toggle="collapse" data-target="#panel-body-4" aria-expanded="true">
              <h4> Customer After Call Survay<span class="fr"><i class="fas fa-plus"></i></span></h4>	
            </div>
          <div class="accordion-body help-manual-groups collapse show" id="panel-body-4" data-parent="#accordion">
            <div class="accord-btn-group">
              <div class="row">
                <div class="col-sm-6 col-12"> 
                  <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/Customer After Call Survay.pdf')" target="_blank" class="btn btn-info">Customer After Call Survay<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
                </div>
                
                
              </div>
            </div>
          </div>
        </div>
      </div> -->
<!-- 
      <div id="accordion" *ngIf="h_dialer">
        <div class="accordion">
          <div class="accordion-header" role="button" data-toggle="collapse" data-target="#panel-body-5" aria-expanded="true">
            <h4> Dialer<span class="fr"><i class="fas fa-plus"></i></span></h4>	
          </div>
        <div class="accordion-body help-manual-groups collapse show" id="panel-body-5" data-parent="#accordion">
          <div class="accord-btn-group">
            <div class="row">
              <div class="col-sm-6 col-12"> 
                <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/Dialer.pdf')" target="_blank" class="btn btn-info">Dialer<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
              </div>
            
              
            </div>
          </div>
        </div>
      </div>
    </div> -->

   <!--  <div id="accordion" *ngIf="h_pred">
      <div class="accordion">
        <div class="accordion-header" role="button" data-toggle="collapse" data-target="#panel-body-6" aria-expanded="true">
          <h4> PredictiveDialer<span class="fr"><i class="fas fa-plus"></i></span></h4>	
        </div>
      <div class="accordion-body help-manual-groups collapse show" id="panel-body-6" data-parent="#accordion">
        <div class="accord-btn-group">
          <div class="row">
            <div class="col-sm-6 col-12"> 
              <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/help_campaign.pdf')" target="_blank" class="btn btn-info">Campaign<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
            </div>
            <div class="col-sm-6 col-12"> 
              <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/help_campaign_contacts .pdf')" target="_blank" class="btn btn-info">Campaign Contacts<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
            </div>
            <div class="col-sm-6 col-12"> 
              <a (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/help_move_to_camp.pdf')" target="_blank" class="btn btn-info">Move contact to Specific List<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

 <!--  <div id="accordion">
    <div class="accordion">
      <div class="accordion-header" role="button" data-toggle="collapse" data-target="#panel-body-7" aria-expanded="true">
        <h4> Messaging<span class="fr"><i class="fas fa-plus"></i></span></h4>	
      </div>
    <div class="accordion-body help-manual-groups collapse show" id="panel-body-7" data-parent="#accordion">
      <div class="accord-btn-group">
        <div class="row">
          <div *ngIf="h_sms" class="col-sm-6 col-12"> 
            <a  (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/sms_help.pdf')" target="_blank" class="btn btn-info">SMS<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
          </div>
          <div *ngIf="h_chat" class="col-sm-6 col-12"> 
            <a  (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/help_webchat.pdf')" target="_blank" class="btn btn-info">WebChat<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
          </div>
          <div *ngIf="h_int_chat" class="col-sm-6 col-12"> 
            <a  (click)="showdoc('https://omni.mconnectapps.com/api/v1.0/Help_manuals/internal-chat-help.pdf')" target="_blank" class="btn btn-info">InternalChat<span class="btn-icon icon-right"><i class="fas fa-arrow-right"></i></span></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->


  <!--   </div>
  </div>
</div>
 -->


<!----------------demo blog----------------->


<!-- <div class="col-12 col-lg-12">
  <div class="card">    
    <div class="card-body">
  <div class="row">
    <div  class="col-12 col-sm-6 col-md-6 col-lg-3">

      <article   class="article">

        <div class="article-header">
          <div class="article-image">
            <img style="width: 100%;" src="assets/img/custom-images/dashboard/referral-icon.svg" onerror="this.src='assets/img/custom-images/dashboard/referral-icon.svg'"  alt="avatar">
            
          </div>
          <div class="article-title">
  <h2><a style="filter:brightness(950%)" target="_blank">Call Recording Management Solution for 3CX</a></h2>

          </div>
        </div>
        <div class="article-details" style="min-height: 228px;border-radius: 10px;">
            <p id=chat-message>mConnect offers a call recording solution that comes bundled with high quality and clarity of sound. The feature is designed to replicate the sound frequencies properly for both active and</p>

            
            <div class="article-cta">
            <a target="_blank" class="btn btn-info">View Video</a>
            </div>
        </div>
      </article>     
    </div>
  </div>   
</div>
</div> 
</div>  -->

<!--------------------------------------------------------------->


<div class="col-12 col-lg-12">
  <div class="card">    
    <div class="card-body">
  <div class="row">
    <!-- <div *ngFor="let item of items" class="col-12 col-sm-6 col-md-6 col-lg-3"> -->
    <div *ngFor="let item of blog_list" class="col-12 col-sm-6 col-md-6 col-lg-3">

      <article   class="article">
      <!-- <article (click)="showvid(item.video_link,item.video_name)"  class="article"> -->

        <div class="article-header">
          <div class="article-image">
            <!-- <img style="width: 100%;" src="https://erp.cal4care.com/cms_new/images/online_products/{{item.video_image_name}}"  onerror="this.src='assets/images/user.jpg'"  alt="avatar"> -->
            <img style="width: 100%;" src="{{item.Image_url}}" onerror="this.src='item.Image_url'"  alt="avatar">
            
          </div>
          <div class="article-title">
          <!-- <h2><a style="filter:brightness(950%)" target="_blank">{{item.video_name}}</a></h2> -->
  <h2><a style="filter:brightness(950%)" target="_blank">{{item.Title}}</a></h2>

          </div>
        </div>
        <div class="article-details" style="min-height: 228px;border-radius: 10px;">
          <div class="user-detail-name">
            <b class="blue-clr">{{item.display_name}}</b>
            <br>
            <b class="blk-clr">{{item.post_date}}</b>
          </div>
          <br>
            <!-- <p id=chat-message>{{item.video_description}}</p> -->
            <div [innerHTML]="replace(item.Short_Content)"></div>
            <!-- <p id=chat-message>{{item.Short_Content}}</p> -->

            
            <div class="article-cta read_more">
            <a target="_blank" class="btn btn-info" href="{{item.Post_url}}">Read More</a>
            </div>
        </div>
      </article>     
    </div>
  </div>   
</div>
</div> 
</div> 

  
            <!-- Video Modal -->
       <!--      <div class="modal fade bd-example-modal-md" id="video_play">
              <div class="modal-dialog modal-md"  style="max-width: 1200px;">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" style="color:crimson" id="myLargeModalLabel" >{{this.vid_name}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                            <iframe [src]="this.video_link | safe"  width="100%" style="height: -webkit-fill-available" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                          
                  </div>     
                  <div class="modal-footer" >
                      <div class="buttons">
                          <input type="button" data-dismiss="modal" class="btn btn-outline-secondary" value="close">
                      </div>
                  </div>
            
                </div>
              </div>
            </div>      -->      
<!-- Video Modal  End-->
<!-- Document Modal  start-->

<!-- <div class="modal fade bd-example-modal-md" id="document_model">
  <div class="modal-dialog modal-md"  style="max-width: 1200px;">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" style="color:crimson" id="myLargeModalLabel" >Help Manual</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
                <iframe [src]="this.doc_link | safe"  width="100%" style="height: -webkit-fill-available" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>     
      <div class="modal-footer" >
          <div class="buttons">
              <input type="button" data-dismiss="modal" class="btn btn-outline-secondary" value="close">
          </div>
      </div>

    </div>
  </div>
</div>   -->
<!-- Document Modal End-->

<div class="card-footer text-right" *ngIf="recordNotFound == false">
  <nav class="d-inline-block">
    <ul class="pagination mb-0"  *ngIf="paginationData.info == 'show'">
      <li class="page-item">
        <a [class]="paginationData.backtab=='show' ? 'page-link' :'page-link disabled'" href="javascript:void(0)" (click)="paginationData.backtab=='show' ? get_blogdata({'search_text':'','offset':paginationData.start}) : false"><i class="fas fa-angle-left"></i></a>
      </li>
      <li class="page-item" *ngIf="paginationData.backtab =='show'">
        <a class="page-link" href="javascript:void(0)" (click)="get_blogdata({'search_text':'','offset':paginationData.back})"><i class="fas fa-angle-double-left"></i></a>
      </li>
      <li [class]="pagination.load ==false ? 'page-item active' :'page-item'" *ngFor="let pagination of paginationData.data;let i=index">
        <a class="page-link" href="javascript:void(0)" (click)=" pagination.load ==true ? get_blogdata({'search_text':'','offset':pagination.offset_count}) : false">{{pagination.btn_length}} <span class="sr-only" *ngIf="pagination.load ==false">(current)</span></a>
      </li>
      <li class="page-item" *ngIf="paginationData.nexttab =='show'">
        <a class="page-link" href="javascript:void(0)" (click)="get_blogdata({'search_text':'','offset':paginationData.next})"><i class="fas fa-angle-double-right"></i></a>
      </li>
      <li class="page-item">
        <a [class]="paginationData.nexttab =='show' ? 'page-link' : 'page-link disabled'" href="javascript:void(0)" (click)="paginationData.nexttab =='show' ? get_blogdata({'search_text':'','offset':paginationData.end}) : false"><i class="fas fa-angle-right"></i></a>
      </li>
    </ul>
  </nav>
</div>


</div>
      
          <!--------------------------
            Help Manual End
            ---------------------------->